import axios from "axios";
const prefix = process.env.NODE_ENV == "development" ? "http://www.nbd.com.cn" : "https://www.nbd.com.cn";
export default {
    getAllCodeAndName() {
        return axios.get(prefix + "/stock-indicators-quantification/getAllCodeAndName");
    },
    getTodayYelp() {
        return axios.get("/course/Activity/getTodayYelp");
    },
    ifHasIn() {
        return axios.get("/course/Activity/ifHasIn");
    },
    firstIn() {
        return axios.get("/course/Activity/firstIn");
    }
}